/*** Checkout ***/
import * as Darby from './darby_alerts';
import { loadScript } from "@paypal/paypal-js"; // See https://www.npmjs.com/package/@paypal/paypal-js for instructions

(async function() {
  function getContactInfo(searchString){
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/phones/search_contact',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          search_string: searchString,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.full_name) {
            $('#card-holder-name').val(data.full_name);
            $('#full_name').val(data.full_name);
          }
          if (data.email) {
            $('#email').val(data.email);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
          // console.log(jqXHR);
        }
      }
    );
  }

  const sendForm = document.getElementById('payment-form');
  if (sendForm) {
    $('#display_number').keyup(function (event) {
      const numbers = $(this).val().replace(/[^0-9]/g, '');
      if (numbers.length > 9) {
        getContactInfo($(this).val());
      }
    });
  }

  const payPalID = $('#paypal_id').val();
  if (payPalID) {
    const cardButton = document.getElementById('credit-card-submit-button');
    const cardWait = document.getElementById('card-wait');
    if (payPalID) {
      // PayPal
      loadScript({
          clientId: payPalID,
          enableFunding: "venmo",
          components: "buttons,card-fields",
        })
        .then((paypal) => {
          async function adjustCounts(order_id, direction) {
            console.log('adjustCounts started')
            const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
            const response = await fetch('/orders/adjust_counts', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': CSRF_TOKEN
              },
              body: JSON.stringify({
                order_id: order_id,
                direction: direction,
              })
            });
            const data = await response.json();
            console.log('Got response')
            if (data.status !== 'success') {
              console.log('error: '+data.message);
              throw new Error(data.message);
            }
            console.log('Limited Quantities Adjusted: ' + direction);
            return data;
          }

          async function createOrderCallback(data = null, actions = null) {
            console.log ('createOrder');
            const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
            const order_id = $('#order_id').val();
            const amount = $('#amount').val();
            try {
              await adjustCounts(order_id, 'down');
              const createOrderPayload = {
                purchase_units: [
                  {
                    amount: {
                      value: amount,
                    },
                  },
                ],
              };
              if (data?.fundingSource === 'venmo') {
                createOrderPayload.payment_source = {
                  venmo: { experience_context: { shipping_preference: 'NO_SHIPPING' } }
                };
              }
              // PayPal Venmo
              console.log('data: ');
              console.log(data);
              console.log('actions: ');
              console.log(actions);
              if (actions) {
                console.log('Has actions');
                return actions.order.create(createOrderPayload);
              }
              // Card
              console.log('Create Order for Card');
              if (cardButton) cardButton.style.display = 'none';
              if (cardWait) cardWait.style.display = 'block';
              const response = await fetch('/subscriptions/paypalCreateOrder', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'X-CSRF-TOKEN': CSRF_TOKEN
                },
                body: JSON.stringify({
                  order_id: order_id,
                  amount: amount,
                })
              });
              console.log('Response: ');
              console.log(response);
              const data = await response.json();
              if (data.status !== 'success' || !data.orderID) {
                throw new Error('Order ID not returned');
              }
              console.log('Order ID ' + data.orderID);
              return data.orderID;
            } catch (error) {
              console.log('Error during create Order.');
              await adjustCounts(order_id, 'up');
              throw error;
            }
          }

          async function capturePaymentHandler (details) {
            console.log ('capturePayment');
            try {
              console.log('details: ');
              console.log(details);
              console.log('details.payer: ');
              console.log(details.payer);
              const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
              const order_id = $('#order_id').val();
              //alert(JSON.stringify(details, null, 2));
              await adjustCounts(order_id, 'up');
              /*
                payer {
                  email_address
                  payer_id
                  name {
                    given_name
                    surname
                  }
                  phone {  (Contact Telephone Number option in Profile & Settings for merchant's
                    phone_type
                    phone_number{
                      national_number
                    }
                  }
                  birth_date (yyyy-mm-dd)
                  tax_info
                  address {
                    address_line_1
                    address_line_2
                    admin_area_1
                    admin_area_2
                    postal_code
                    country_code
                  }
                }
              */
              let paymentType = null;
              if (details.payment_source) {
                paymentType = Object.keys(details.payment_source)[0];
              }
              const paymentMethod = paymentType ?? 'card-pp';
              const captureId = details.purchase_units?.[0]?.payments?.captures?.[0]?.id ?? null;
              const captureStatus = details.purchase_units?.[0]?.payments?.captures?.[0]?.status;
              const paymentStatus = captureStatus ?? details.status ?? null;
              let payerName = details.payer?.name
                ? details.payer.name.given_name + ' ' + details.payer.name.surname
                : null;
              const fullName = $('#full_name').val() || payerName;
              payerName = payerName || fullName;
              const birthDate = details.payer?.birth_date;
              let phoneNumber = $('#display_number').val() || details.payer?.phone?.phone_number?.national_number;
              let payerPhoneNumber = details.payer?.phone?.phone_number?.national_number || $('#display_number').val();
              const email = $('#email').val() || details.payer?.email_address;
              const payerEmail = details.payer?.email_address || $('#email').val();
              const amount = details.purchase_units ? details.purchase_units[0].payments.captures[0].amount.value : $('#amount').val();
              const response = await fetch('/subscriptions/singleCharge', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'X-CSRF-TOKEN': CSRF_TOKEN
                },
                body: JSON.stringify({
                  order: order_id,
                  details: details,
                  paypal_order_id: details.id,
                  capture_id: captureId,
                  payment_status: paymentStatus,
                  full_name: fullName,
                  payer_name: payerName,
                  birth_date: birthDate,
                  display_number: phoneNumber,
                  payer_phone_number: payerPhoneNumber,
                  email: email,
                  payer_email: payerEmail,
                  amount: amount,
                  user: $('#active_user').val(),
                  paymentMethod: paymentMethod,
                  nonce: null,
                  return_url: window.location.href,
                })
              });
              const data = await response.json();
              if (data.status === 'success') {
                const msg = paymentStatus === 'PENDING'
                  ? 'Payment processing. You will receive confirmation shortly.'
                  : 'Thank You!';
                Darby.alertModal(msg);
                setTimeout(() => {
                  window.location.replace(data.html);
                }, 3000);
              } else {
                if (cardButton) cardButton.style.display = 'block';
                if (cardWait) cardWait.style.display = 'none';
                console.log(data.text);
                throw new Error(data.text);
              }
            } catch (error) {
              throw error;
            }
          };

          async function onApproveCallback(data, actions = null) {
            try {
              console.log('approve');
              console.log('data: ');
              console.log(data);
              console.log('actions: ');
              console.log(actions);
              if (data?.paymentSource === "paypal") {
                // Paypal or Venmo
                console.log('Paypal or Venmo');
                return actions.order.capture().then(capturePaymentHandler); // This actually completes the charge
              } else {
                // Credit Card
                console.log('Call paypalCapturePayment');
                const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
                let response = await fetch('/subscriptions/paypalCapturePayment', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': CSRF_TOKEN
                  },
                  body: JSON.stringify({
                    paypal_order_id: data.orderID,
                    payment_source: data.paymentSource,
                  })
                });
                console.log('Got paypalCapturePayment response');
                const capture_data = await response.json();
                if (capture_data.status === 'success') {
                  console.log('Success');
                  response =await capturePaymentHandler(capture_data.data);
                  console.log('Capture Payment Response: ' + response);
                } else {
                  console.log(capture_data.text);
                  throw new Error(capture_data.text);
                  //Darby.alertModal(capture_data.text);
                }
                return response;
              }
            } catch (error) {
              console.error(error.message);
              throw error;
            }
          }

          async function cancelCallback(data) {
            const order_id = $('#order_id').val();
            await adjustCounts(order_id, 'up');
            if (cardButton) cardButton.style.display = 'block';
            if (cardWait) cardWait.style.display = 'none';
            console.error(data);
            Darby.alertModal('Checkout Canceled');
          }

          async function errorCallback(error) {
            const order_id = $('#order_id').val();
            await adjustCounts(order_id, 'up');
            if (cardButton) cardButton.style.display = 'block';
            if (cardWait) cardWait.style.display = 'none';
            const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
            fetch('/log-client-error', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': CSRF_TOKEN },
              body: JSON.stringify({ message: error.message, context: 'checkout errorCallback', url: window.location.href }),
            }).catch(() => {});
            Darby.alertModal('Your payment could not be processed. Please check your card details and try again, or contact us for help.');
          }

          // PayPal and Venmo
          const fundingSources = [
            paypal.FUNDING.PAYPAL,
            paypal.FUNDING.VENMO,
            paypal.FUNDING.CARD
          ]
          for (const fundingSource of fundingSources) {
              if ((fundingSource === 'venmo' || fundingSource === 'paypal') && $('#paypal-button-container').length) {
                // Render PayPal or Venmo
                const paypalButtonsComponent = paypal.Buttons({
                  fundingSource: fundingSource,
                  // optional styling for buttons
                  // https://developer.paypal.com/docs/checkout/standard/customize/buttons-style-guide/
                  style: {
                    shape: 'pill',
                    height: 40,
                  },
                  createOrder: createOrderCallback,
                  onApprove: onApproveCallback,
                  onCancel: cancelCallback,
                  onError: errorCallback,
                })
                if (paypalButtonsComponent.isEligible()) {
                  paypalButtonsComponent
                    .render('#paypal-button-container')
                    .catch((err) => {
                      console.error('PayPal Buttons failed to render')
                    })
                } else {
                  console.log('The funding source ' + fundingSource + ' is ineligible')
                }
              } else if (fundingSource === 'card' && $('#card-field-container').length) {
                // Render Credit Card
                const cardFields = paypal.CardFields({
                  createOrder: createOrderCallback,
                  onApprove: onApproveCallback,
                  //onCancel: cancelCallback,
                  onError: errorCallback,
                });
                if (cardFields.isEligible()) {
                  /*
                  const nameField = cardFields.NameField({
                    placeholder: "Name on Card",
                    inputEvents: {
                      onChange: (event)=> {
                        console.log("returns a stateObject", event);
                      }
                    },
                    style: {
                      ".invalid": {
                        "color": "purple",
                      }
                    }
                  });
                  const cardNameContainer = document.getElementById("name");
                  nameField.render(cardNameContainer);
                   */
                  const numberField = cardFields.NumberField();
                  const cardNumberContainer = document.getElementById("card-number");
                  numberField.render(cardNumberContainer);
                  const expiryField = cardFields.ExpiryField();
                  const cardExpiryContainer = document.getElementById("expiration-date");
                  expiryField.render(cardExpiryContainer);
                  const cvvField = cardFields.CVVField();
                  const cardCvvContainer = document.getElementById("cvv");
                  cvvField.render(cardCvvContainer);

                  //cardFields.render('#card-field-container'); // renders card number, date, cvv on one line
                  const cardSubmitButton = document.getElementById("credit-card-submit-button");
                  cardSubmitButton.addEventListener("click", () => {
                    // Get all required fields
                    const requiredFields = document.querySelectorAll('[required]');
                    let allFieldsFilled = true;
                    // Check each required field
                    requiredFields.forEach(function(field) {
                      if (!field.value.trim()) {
                        allFieldsFilled = false;
                        field.style.borderColor = 'red';  // Highlight the empty field
                      } else {
                        field.style.borderColor = '';  // Reset the border color if filled
                      }
                    });
                    // If any required field is empty, prevent form submission and show alert
                    if (!allFieldsFilled) {
                      Darby.alertModal('Please fill out all required fields.');
                      console.error('Missing Required Fields')
                      event.preventDefault();
                    } else {
                      // All required fields are filled
                      cardFields.submit().then(() => {
                        // Submit success
                      }).catch((error) => {
                        Darby.alertModal(error.message);
                      });
                    }

                  });
                } else {
                  console.log('The funding source ' + fundingSource + ' is ineligible')
                }
              }
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  }

})();
